import { UsageMetricsClient } from "@formant/core/client/UsageMetricsClient";
import { IUsageCost } from "@formant/core/model/IUsageCost";
import { Uuid } from "@formant/core/model/Uuid";

import { IAuthStore } from "./IAuthStore";
import { IUsageMetricsStore } from "./IUsageMetricsStore";
import { StoreCache } from "./StoreCache";

export class UsageMetricsStore implements IUsageMetricsStore {
    private usageCostData = new StoreCache<Uuid, IUsageCost[]>();

    constructor(
        private usageMetricsClient: UsageMetricsClient,
        private authStore: IAuthStore,
    ) {}

    getUsageCosts(organizationId: Uuid): IUsageCost[] | false | undefined {
        const userIsBillingAdministrator =
            this.authStore.userRole &&
            this.authStore.hasAccess("billing", "administrator", "billing");

        if (!userIsBillingAdministrator) {
            return false;
        }

        return this.usageCostData.get(organizationId, async () =>
            this.usageMetricsClient.getUsageCosts(
                await this.authStore.token(),
                organizationId,
            ),
        );
    }
}
